import { Host, h } from "@stencil/core";
import { uniqueId, debounce } from "lodash-es";
export class GoToTop {
    constructor() {
        this.offset = 200;
        this.active = false;
    }
    componentWillLoad() {
        // get body id or generate a new one if it doesn't exist
        this.targetId = document.body.getAttribute('id');
        if (!this.targetId) {
            this.targetId = uniqueId('body-');
            document.body.setAttribute('id', this.targetId);
        }
    }
    componentDidLoad() {
        window.onscroll = debounce(() => {
            this.active = window.scrollY > this.offset;
        }, 200);
    }
    render() {
        const { active } = this;
        return (h(Host, { key: '7477a98588e745f879bdbf469021d6bd3af8d6ae', class: { active } }, h("go-button", { key: '2ed2579eca645d6ca74471abc88d5eaea5481640', variant: "primary", flat: true, href: `#${this.targetId}`, id: "go-to-top-btn", type: "button", icon: true, round: true, "aria-labelledby": "go-to-top-btn-tooltip" }, h("svg", { key: '73cab3e976da71b09400d5750c491f199ac5ced7', xmlns: "http://www.w3.org/2000/svg", fill: "none", stroke: "currentColor", "stroke-linecap": "round", "stroke-linejoin": "round", "stroke-width": "2", viewBox: "0 0 24 24" }, h("path", { key: 'd53faba8f1b3fcd46ce2241e9d8cd82513351359', d: "m18 15-6-6-6 6" }))), h("go-tooltip", { key: 'd9b166056a1d6102a9a53a8d7641be33613e580f', id: "go-to-top-btn-tooltip", placement: "left", "trigger-id": "go-to-top-btn" }, "Back to top")));
    }
    static get is() { return "go-to-top"; }
    static get originalStyleUrls() {
        return {
            "$": ["go-to-top.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["go-to-top.css"]
        };
    }
    static get properties() {
        return {
            "offset": {
                "type": "number",
                "mutable": false,
                "complexType": {
                    "original": "number",
                    "resolved": "number",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "how far from the top of the page the button should be shown (in px)"
                },
                "attribute": "offset",
                "reflect": false,
                "defaultValue": "200"
            }
        };
    }
    static get states() {
        return {
            "active": {}
        };
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=go-to-top.js.map
